<script>
  export default {
    data() {
      return {
        aux:null,
        latitude:null,
        longitude:null,
        validate:false,
        maker:null,
        addressN:null,
        positionA:null,
      };
    },
    props: {
      google: {
        type: Object,
        required: true
      },
      map: {
        type: Object,
        required: true
      },
      marker: {
        type: Object,
        required: true
      },
      validateA:{
        required:true
      },
      newAutocomplete:{
        required:true
      }
    },
    watch:{
      aux:function()
      {
        console.log(this.aux);
      },
      addressN:function(){
        console.log('New Address: '+this.address);
      },
    },
    async mounted() {
      var latlng=null;
      if(this.validateA==true)
      {
        //this.getFullAddress();
        this.positionA=this.marker.position;
        localStorage.setItem("lat",this.marker.position.lat);
        localStorage.setItem("lng",this.marker.position.lng); 
      }
      else{
        this.positionA=this.marker.position;
        localStorage.setItem("lat",this.marker.position.lat);
        localStorage.setItem("lng",this.marker.position.lng); 
        latlng=this.marker.position;
        var geocoderA = new this.google.maps.Geocoder();
        // console.log('Entra');
          geocoderA.geocode({'location': latlng}, function(results, status) {
            if (status === 'OK') {
              var address= {
                calle: '',
                num_exterior: '',
                interior: '',
                colonia: '',
                ciudad: '',
                estado: '',
                cp: null,        
              };
              this.addressN=results[0].formatted_address;
              address.calle=results[0].address_components[1].long_name;
              address.num_exterior=results[0].address_components[0].long_name;
              address.colonia=results[0].address_components[2].long_name;
              address.ciudad=results[0].address_components[4].long_name;
              address.estado=results[0].address_components[3].long_name;
              address.cp=results[0].address_components[6].long_name;
              localStorage.setItem("address",results[0].formatted_address);
              localStorage.setItem("calle",address.calle);
              localStorage.setItem("num_exterior",address.num_exterior);
              localStorage.setItem("colonia",address.colonia);
              localStorage.setItem("ciudad",address.ciudad);
              localStorage.setItem("cp",address.cp);
              localStorage.setItem("estado",address.estado);
              localStorage.setItem("validation",true);
              // console.log(address);
            }else{
              return ("Error: "+status);
            }

          }); 
      }
      if(this.newAutocomplete==true)
      {
        //this.getFullAddress();
        // console.log('hello Address'+this.marker.position);
        this.positionA=this.marker.position;
        localStorage.setItem("lat",this.marker.position.lat);
        localStorage.setItem("lng",this.marker.position.lng); 
      }
      this.marker = new this.google.maps.Marker({
        position: this.positionA,
        marker: this.marker,
        animation: this.google.maps.Animation.DROP,
        map: this.map,
        title: this.marker.title,
        draggable:false,
        icon:'https://cdn3.iconfinder.com/data/icons/bunch-of-stuff/126/slice87-64.png',
      });
      this.marker.bindTo('position',this.map,'center');
      this.aux=this.marker;
      this.map.setZoom(10); 
      this.map.panTo(this.marker.position);
      var geocoder2 = new this.google.maps.Geocoder();
      //this.marker.addListener('click', this.toggleBounce);
      var mapi=this.map; 
      this.google.maps.event.addListener(this.map,'dragend', function(){
        // console.log(mapi.getCenter().lat(),': ',mapi.getCenter().lng());
        localStorage.setItem("latitude",mapi.getCenter().lat());
        localStorage.setItem("longitude",mapi.getCenter().lng());
        this.longitude=mapi.getCenter().lng();
        this.latitude=mapi.getCenter().lat();
        var latlng = {lat: mapi.getCenter().lat(), lng: mapi.getCenter().lng()};
          geocoder2.geocode({'location': latlng}, function(results, status) {
            if (status === 'OK') {
              var address= {
                calle: '',
                num_exterior: '',
                interior: '',
                colonia: '',
                ciudad: '',
                estado: '',
                cp: null,        
              };
              this.addressN=results[0].formatted_address;
              address.calle=results[0].address_components[1].long_name;
              address.num_exterior=results[0].address_components[0].long_name;
              address.colonia=results[0].address_components[2].long_name;
              address.ciudad=results[0].address_components[4].long_name;
              address.estado=results[0].address_components[3].long_name;
              address.cp=results[0].address_components[6].long_name;
              localStorage.setItem("address",results[0].formatted_address);
              localStorage.setItem("calle",address.calle);
              localStorage.setItem("num_exterior",address.num_exterior);
              localStorage.setItem("colonia",address.colonia);
              localStorage.setItem("ciudad",address.ciudad);
              localStorage.setItem("cp",address.cp);
              localStorage.setItem("estado",address.estado);
              localStorage.setItem("validation",true);
              // console.log(address);
            }else{
              return ("Error: "+status);
            }

          });         
      });
/*       this.marker.addListener( 'dragend', function (event)
        {
          console.log(event);
          var pos = this.getPosition();
          localStorage.setItem("latitude",this.getPosition().lat());
          localStorage.setItem("longitude",this.getPosition().lng());
          this.longitude=this.getPosition().lng();
          this.latitude=this.getPosition().lat();
          var latlng = {lat: this.getPosition().lat(), lng: this.getPosition().lng()};
          this.map.setCenter(latlng);
          geocoder2.geocode({'location': latlng}, function(results, status) {
            if (status === 'OK') {
              var address= {
                calle: '',
                num_exterior: '',
                interior: '',
                colonia: '',
                ciudad: '',
                estado: '',
                cp: null,        
              };
              this.addressN=results[0].formatted_address;
              address.calle=results[0].address_components[1].long_name;
              address.num_exterior=results[0].address_components[0].long_name;
              address.colonia=results[0].address_components[2].long_name;
              address.ciudad=results[0].address_components[4].long_name;
              address.estado=results[0].address_components[3].long_name;
              address.cp=results[0].address_components[6].long_name;
              localStorage.setItem("address",results[0].formatted_address);
              localStorage.setItem("calle",address.calle);
              localStorage.setItem("num_exterior",address.num_exterior);
              localStorage.setItem("colonia",address.colonia);
              localStorage.setItem("ciudad",address.ciudad);
              localStorage.setItem("cp",address.cp);
              localStorage.setItem("estado",address.estado);
              localStorage.setItem("validation",true);
              console.log(address);
            }else{
              return ("Error: "+status);
            }

          });       
          console.log(pos);
        }); */
    },
    methods:{
/*       toggleBounce() {
        if (this.marker.getAnimation() !== null) {
          this.marker.setAnimation(null);
        } else {
          this.marker.setAnimation(this.google.maps.Animation.BOUNCE);
        }
      }, */
      async getFullAddress(){
        var address=this.address;
        const getAddress = address => {
            return new Promise((resolve, reject) => {
                const geocoder = new this.google.maps.Geocoder();
                geocoder.geocode({address: address}, (results, status) => {
                    if (status === 'OK') {
                        resolve(results[0].geometry.location);
                    } else {
                        reject(status);
                    }
                });
            }).catch(error => {
              console.log('Ocurrio un problema: '+error);
             });
        };
        let location = await getAddress(address);
        // console.log('HELLLOS: '+location);
        localStorage.setItem("lat",location.lat());
        localStorage.setItem("lng",location.lng());   
        this.positionA= { lat: location.lat(), lng: location.lng() }
      }
    },
    render: h => h()
  };
 
</script>